module.exports = __webpack_public_path__ + "static/media/christmas-theme.4bb7d41a.png";